import { competitionsMap as bundledCompetitionsMap } from "tokens/build/js/competitions-map";
import { getCompetitionsMap, hasCompetitionsMap } from "./useCuiConfig";

export type CompetitionInfoReturnType = {
  name: string;
  abbreviation: string;
  sport: string;
  location?: {
    location: string;
    city: string;
    state?: string;
    country: string;
    countryCID: string;
  };
  metadata: {
    colors: {
      primary: {
        value: string;
        type: string;
      };
      secondary: {
        value: string;
        type: string;
      };
    };
    images: {
      primary: {
        type: string;
        name: string;
        ext: string;
        folder: string;
      };
      location?: {
        name: string;
        type: string;
        ext: string;
        folder: string;
      };
      backgrounds?: Array<{
        name: string;
        type: string;
        ext: string;
        folder: string;
      }>;
      associations?: Array<{
        type: string;
        name: string;
        ext: string;
        folder: string;
      }>;
    };
  };
  cid: string;
} | null | undefined;

function getActiveCompetitionsMap(): Record<string, unknown> {
  if (hasCompetitionsMap()) return getCompetitionsMap()!;
  return bundledCompetitionsMap;
}

export const getCompetitionInfo = (competition): CompetitionInfoReturnType => {
  const searchTerm = competition && typeof competition === "string" ? competition?.toLowerCase() : "";
  const map = getActiveCompetitionsMap();
  if (searchTerm in map) return map[searchTerm] as CompetitionInfoReturnType;
  return null;
};

/** @deprecated Use getCompetitionInfo instead */
export const getLeagueInfo = getCompetitionInfo;

/** @deprecated Use CompetitionInfoReturnType instead */
export type LeagueInfoReturnType = CompetitionInfoReturnType;
